module.exports = __webpack_public_path__ + "static/media/Jim Seay Headshot.ed215820.jpeg";